import kea = require('node_modules/kea-react/dist/index');
import models = require("app/models/requireme");
import { rpcController } from "../rpc";
const controller = rpcController("RutaEntregaDomicilio");
import { cacheResource, bindResource, addOnInvalidateHandler, invalidateResource } from "kea-resource";

type Entity = models.RutaEntregaDomicilio;
type EntityDto = models.RutaEntregaDomicilioDto;

export const  RutaEAD = cacheResource({
     /**
         * Obtiene una entidad
         * @param id Id de la entidad
         */
        Get: async (id: number): Promise<Entity> => await controller('Get', {id}), 

        /**Obtiene todas las entidades filtradas por la zona */
        Query: async (filtro: models.FiltroRutaEntregaDomicilio): Promise<EntityDto[]> => {
            const x = 1;
            return await controller('Query', {}, filtro);
        } , 

        /**Agrega una entidad */
        Add: async (entity: Entity): Promise<number> => await controller('Add', {}, entity), 

        /**
         * Actualiza la entidad
         * @param entity 
         */
        Update: async (entity: Entity): Promise<void> => await controller('Update', {}, entity), 

        /**
         * Borra un ticket
         * @param id 
         */
        Delete: async (id: number): Promise<void> => await controller('Delete', {id}), 
}, {
    Query: true,
}, {
    Add: true,
    Update: true,
    Delete: true
});


// WEBPACK FOOTER //
// ./app/resources/items/rutaead.tsx